import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Icon, Divider } from 'antd';
import { Beneficiary } from '../../../../models';
import { connect } from 'react-redux';


let EditBeneficiaryForm = (props) => {
    const { form, beneficiary } = props;
    const { getFieldDecorator } = form;
    const validations = Beneficiary.validations;

    const onSubmit = (e) => {
        e.preventDefault();
        form.validateFields((err, values) => {
            if (err) return;
            props.onSubmit(form.getFieldsValue());
        });
    }

    const renderBankAccountDetailsForm = () => {
        return (
            <>
                <Form.Item label="Account Number">
                    {getFieldDecorator("account_number", {
                        initialValue: beneficiary.account_number,
                        rules: validations.account_number
                    })(<Input autoComplete='off' disabled={beneficiary?.is_edit} prefix={<Icon type="bank" />} />)}
                </Form.Item>

                <Form.Item className="mb-0" label="Account IFSC Code">
                    {getFieldDecorator("ifsc", {
                        initialValue: beneficiary.account_ifsc,
                        rules: validations.ifsc
                    })(<Input autoComplete='off' disabled={beneficiary?.is_edit} prefix={<Icon type="bank" />} />)}
                </Form.Item>
                
                <Divider style={{ marginTop: 10, marginBottom: 10, background: "#dddddd" }} />
            </>
        )
    };

    const renderUpiDetailsForm = () => {
        return (
            <Form.Item label="UPI Handle">
                {getFieldDecorator("upi_handle", {
                    initialValue: beneficiary.upi_handle,
                    rules: validations.upi_handle
                })(<Input autoComplete='off' disabled={props?.beneficiary?.is_edit} id="upi_handle" prefix={<Icon type="qrcode" />}  />)}
            </Form.Item>
        )
    };


    return (
        <Form onSubmit={onSubmit}>
            {getFieldDecorator("id", {
                initialValue: beneficiary.uuid,
                rules: validations.uuid
            })(<Input autoComplete='off' hidden />)}

            {getFieldDecorator("contact_id", {
                initialValue: props.contact.uuid,
                rules: validations.contact_id
            })(<Input autoComplete='off' hidden />)}

            {beneficiary.beneficiary_type == "bank_account" ? renderBankAccountDetailsForm() : renderUpiDetailsForm()}

            <Form.Item label="Beneficiary Name">
                {getFieldDecorator("beneficiary_name", {
                    initialValue: beneficiary.account_name,
                    rules: validations.beneficiary_name
                })(<Input autoComplete='off' prefix={<Icon type="user" />} />)}
            </Form.Item>

            <div className="w-100 d-flex justify-content-end mt-4">
                <Button type="primary" htmlType="submit" loading={props.loading}>Update</Button>
            </div>
        </Form>
    )
};

EditBeneficiaryForm.defaultProps = {
    beneficiary: {},
    contact: {}
}

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
});

EditBeneficiaryForm = Form.create()(EditBeneficiaryForm);

export default connect(mapStateToProps)(EditBeneficiaryForm);